export default "__VITE_ASSET__Mu6nU0HD__"